import { render, staticRenderFns } from "./VFlag.vue?vue&type=template&id=45372b01&"
import script from "./VFlag.vue?vue&type=script&lang=js&"
export * from "./VFlag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports